var render = function render(_c,_vm){return _c('app-md',{staticClass:"v-example-missing text-center",domProps:{"textContent":_vm._s(_vm.parent.$t('missing', _vm.data.attrs))}})
}
var staticRenderFns = []

export { render, staticRenderFns }